/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { LoginForm } from 'components/modules';
import { routes } from 'const';
import { PoweredBy, PortalWelcomeText, PortalFormWrapper, AuthorizationWelcomeText } from 'components/elements';
import { useDeviceDetect } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function Login() {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { isDesktop } = useDeviceDetect();

  return (
    <>
      <PortalFormWrapper>
        <>
          <PortalWelcomeText isForm>{!isDesktop && <AuthorizationWelcomeText />}</PortalWelcomeText>
          <LoginForm onSubmit={() => history.push(routes.appointments)} />
          <Link className={classes.forgotPassword} to={routes.passwordRecovery}>
            {t('forgot_password')}
          </Link>
        </>
      </PortalFormWrapper>
      <PoweredBy />
    </>
  );
}

export default Login;
